import Resource from '../../../resource/Resource';
import { UserStore } from '../stores/UserStore';
import { NotificationServerActionCreators } from '../actions/NotificationServerActionCreators';
import { UserServerActionCreators } from '../actions/UserServerActionCreators';
import { NotificationActions } from '../constants/NotificationActions';

export const NotificationWebAPIUtils = {
  updateLastCheckedTime: (channelId, subscriptionId, lastCheckedTime) => {
    Resource.update('subscription', subscriptionId, 'updateLastCheckedTime', {
      channelId,
      lastCheckedTime,
    }).done((result) => {
      NotificationServerActionCreators.updateLastCheckedTime(
        channelId,
        subscriptionId,
        result.lastCheckedTime
      );
    });
  },

  setAllNotificationsChecked: () => {
    Resource.execute('subscription', 'markAllAsRead').done((result) => {
      NotificationServerActionCreators.setAllNotificationsChecked(
        result.lastCheckedTime
      );
    });
  },

  loadNotifications: (actionType, includeRead, page, itemsPerPage) => {
    const options = {
      itemsPerPage,
      format: 'default',
      includeRead,
      pageNo: page,
    };
    if (actionType !== NotificationActions.ACTION_ALL) {
      options.topics = [actionType];
    }
    Resource.lookup('notification', 'getPaginatedNotifications', options)
      .done((result) => {
        UserServerActionCreators.updateUsers(result.users);
        NotificationServerActionCreators.updateNotifications(
          result.notifications
        );
        let earliestTime = null;
        if (result.notifications.length) {
          earliestTime =
            result.notifications[result.notifications.length - 1].timestamp;
        }
        NotificationServerActionCreators.setFilterStatus(
          actionType,
          includeRead,
          earliestTime,
          result.complete
        );
      })
      .always(() => {
        NotificationServerActionCreators.setLoadingStatus(
          actionType,
          includeRead,
          false
        );
      });
  },

  getNotificationSettings: () => {
    Resource.read(
      'user',
      UserStore.getCurrentUser().userId,
      'getNotificationSettings'
    ).done((result) => {
      NotificationServerActionCreators.updateSettings(result);
    });
  },

  setNotificationSettings: (settings) => {
    Resource.update(
      'user',
      UserStore.getCurrentUser().userId,
      'setNotificationSettings',
      { settings }
    ).done((result) => {
      NotificationServerActionCreators.updateSettings(result);
    });
  },
};
